<style lang="less" scoped>
  .td_left {width: 150px;text-align-last: left;text-indent: 10px;background-color: #fcfcfc;}
  .after {text-align: left;background-color: #fcfcfc;}
  .after .el-button {height: 40px;}
  .f_red {color: red;margin-right: 5px;}
  .f_hid {color: #ffffff;margin-right: 5px;}
  tr,td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
  .tr .td {float: left;}
  .tr {width: 100%;height: 50px;}
  .td {margin-left: 10px;}
  table {border-collapse: collapse;width: 100%;}
  .el-checkbox__inner {border-radius: 50%;}
  .first .introduce {width: 100%;}
  .first /deep/ .el-input {width: 400px;}
  .level /deep/ .el-input {width: 200px;}
  .ssgj_tr /deep/ .el-input {width: 345px;}
  .formBox {padding-bottom: 70px;}
  .btnfixed {margin: 0px auto;height: 60px;z-index: 19999;}
  .btnfixed .el-button {height: 40px;margin: 10px auto;}
  .btnfixed {position: fixed;bottom: 0;left: 0;right: 0;height: 60px;background: #f8f4f4;margin-left: 240px;background-color: #dff0d8;}
  .edui-default /deep/ .edui-editor-iframeholder {height: 40%;}
  .el-form-item {margin-bottom: 0;float: left;}
  .jianjie_tr .el-form-item {width: 99%;}
  .catid_tr .el-form-item:nth-of-type(2) {margin-left: 10px;}
  .tr2 .el-form-item:nth-of-type(2) {margin-left: 10px;}
  /deep/.el-upload-list--picture-card .el-upload-list__item-thumbnail {position: absolute;margin: auto;top: -9999px;right: -9999px;bottom: -9999px;left: -9999px;height: auto}
</style>
<template>
  <div class="first" id="first">
    <el-form ref="form" :model="form" class="formBox" >
      <table>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('name')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>文章标题
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.name" placeholder="请输入标题" class="input title" @blur="detection(11, 110, form.name)"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr>
           <td class="td_left">
             <span v-if="isMandatory('pdf')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>文件上传
          </td>
            <td style="display: flex;">
              <el-upload
                v-if="this.$route.path === '/Kyzhgl'"
                class="upload-demo"
                drag
                :action= url
                :limit="1"
                ref="uploadPic_file"
                :on-success="onFileSuccess"
                :before-upload="beforeUploadFile"
                :on-remove="handleRemoveFile"
                :on-exceed="exceed"
                @mouseover.native="getPdfUrl"
                multiple><i class="el-icon-upload"></i><div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              </el-upload>
              <el-upload
                v-else
                class="upload-demo"
                drag
                :action= url
                :limit="1"
                ref="uploadPic_file"
                :file-list="fileListPDF"
                :on-success="onFileSuccess"
                :before-upload="beforeUploadFile"
                :on-remove="handleRemoveFile"
                :on-exceed="exceed"
                @mouseover.native="getPdfUrl"
                multiple><i class="el-icon-upload"></i><div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              </el-upload>
            </td>
        </tr>
      </table>
    </el-form>
    <div class="btnfixed">
      <el-button type="success" @click="addfn()" v-if="this.$route.path === '/Kyzhgl'">添加</el-button>
      <el-button type="success" @click="modification" v-else-if="this.$route.path === '/KyltPdfUpdate'">确定修改</el-button>
      <el-button @click="cancelfn()" v-if="this.$route.path === '/Kyzhgl'">取消</el-button>
      <el-button @click="backtrack" v-else-if="this.$route.path === '/KyltPdfUpdate'">返回</el-button>

    </div>
  </div>
</template>
<script>
/**
 * 何宽
 * 东盟地学添加
 */
import {mapState} from 'vuex'
export default {
  components: {
  },
  props: ['updataID'],
  data()
  {
    return {
      url: '',
      form: {
        catid: null,
        name: '',
        thumb: '',
        pdf: '',
        introduce: '',
        author: '',
        addtime: '',
        edittime: '',
        hits: 0
      },
      username: '',
      //所属分类数据
      classifydata: [],
      //预览弹框
      dialogVisible: false,
      //预览路径
      dialogImageUrl: '',
      fileList: [{url: ''}],
      fileListPDF: [{url: ''}],
      examine: '',
      //表名
      tabname: 'dmcn_geoscience',
      //fld表数据
      fldData: []
    }
  },
  //根据左侧菜单栏获取模块id
  computed:
  {
    ...mapState({
      curID: state => state.NavID
    }),

    Url()
    {
      return this.url
    }
  },
  watch:
  {
    curID:
    {
      handler(nval, oval)
      {
        //获取分类下拉列表
        window.public.getFldvalue(nval, 'catid').then(ret =>
        {
          this.classifydata = []
          ret.forEach(item => this.classifydata.push({ value: item.id, label: item.dispc }))
        })
      },
      immediate: true
    }
  },
  async created()
  {
    this.isgetData()
    this.fldData = await window.public.validation(this.tabname)
    //根据用户判断审核状态
    let userInfo = JSON.parse(localStorage.getItem('userMsg'))
    this.username = userInfo.userno
    if (userInfo.userno === 'admin')
      this.examine = 0
    else
      this.examine = 1
  },
  methods: {
    //添加
    addfn()
    {
      let obj = {
        cmd: 'add',
        _major: 11,
        _minor: 110,
        retAtt: 1,
        name: this.form.name,
        pdf: this.form.pdf,
        username: this.username,
        addtime: (Date.parse(new Date()) / 1000)
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '添加失败，请检查是否有未填写的内容或者填写不规范', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '添加成功', type: 'success', customClass: 'mzindex'})
          this.$emit('removeTab')
          this.$store.commit('onIsLb', '1')
        }
      })
    },
    //点击文件列表中已上传的文件时的钩子
    handlePictureCardPreview_icon(file)
    {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    //获取文件url地址
    getPdfUrl()
    {
      let that = this
      window.public.onUploadFile(that)
    },
    //获取图片url地址
    getPhoUrl()
    {
      let that = this
      window.public.onUploadPicture(that)
    },
    //获取需要修改的数据
    isgetData()
    {
      if (this.$route.path === '/KyltPdfUpdate')
        this.getData()
      else if (this.$route.path === '/Kyzhgl')
        return false
    },
    getData()
    {
      let paras = {
        cmd: 'query',
        _major: 11,
        _minor: 110,
        _exp: 'id=?',
        types: 'i',
        vals: this.updataID
      }
      window.post.getPost(paras).then((ret) =>
      {
        this.form.id = ret[0].id
        this.form.name = ret[0].name
        this.form.pdf = ret[0].pdf
        this.fileListPDF[0].url = ret[0].pdf
      })
    },
    //修改
    modification()
    {
      let obj = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 110,
        retAtt: 1,
        id: this.form.id,
        name: this.form.name,
        pdf: this.form.pdf,
        username: this.username,
        addtime: (Date.parse(new Date()) / 1000)
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '修改失败', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '修改成功', type: 'success', customClass: 'mzindex'})
          this.dialogVisible = false
          this.$router.push({path: '/Kyzhgl'})
          this.$store.commit('onActiveName', '1')
        }
      })
    },
    //返回
    backtrack()
    {
      this.$router.push({path: '/Kyzhgl'})
      this.$store.commit('onActiveName', '1')
    },
    //图片上传之前的钩子
    beforeUploadPicture(file)
    {
      let that = this
      window.public.beforeUploadPicture(file, that)
    },
    //文件上传之前的钩子
    beforeUploadFile(file)
    {
      let that = this
      window.public.beforeUploadFile(file, that)
    },
    // //上传中
    handlePictureCardPreview(file)
    {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    //图片上传成功
    onSuccess(response)
    {
      let that = this
      window.public.onSuccess(response, that)
    },
    //pdf文件上载成功
    onFileSuccess(response)
    {
      let that = this
      window.public.onFileSuccess(response, that)
    },
    //删除图片
    handleRemovePicture(fileList)
    {
      let that = this
      window.public.handleRemovePicture(fileList, that)
    },
    //删除文件
    handleRemoveFile(fileList)
    {
      let that = this
      window.public.handleRemoveFile(fileList, that)
    },
    //超出上传次数
    exceed()
    {
      this.$message({message: '您已上传过了，若需要换一个，请先删除上一个', type: 'error', customClass: 'mzindex'})
    },
    //取消(移除Tabs页)
    cancelfn()
    {
      this.$emit('removeTab')
    },
    /**
     * 标题检测
     * @param {String} major 主类型
     * @param {String} minor 子类型
     * @param {String} title 标题
     */
    detection(major, minor, title)
    {
      let that = this
      window.public.detection(major, minor, title, that)
    },
    //判断是否必填
    isMandatory(colname)
    {
      return window.public.isMandatory(this.fldData, colname)
    }
  }
}
</script>



// WEBPACK FOOTER //
// static/form/KyltPdfAdd.vue